module.exports = __webpack_public_path__ + "static/event1-ac2d1edf822fd69d4e90a963208040fa.jpeg";